module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-22-d23bb1fcbda2691a4cba6ac4b73947fe.png";